import { createRoute } from "@tanstack/react-router";
import { TeamRosterPage } from "@/components/teams/team-roster-page";
import { Route as authenticatedRoute } from "../_authenticated";

const members = [
  {
    name: "DaShonda Crockett",
    title: "Stone Setter",
  },
  {
    name: "Jennifer Tucker",
    title: "Stone Setter",
  },
  {
    name: "Mandy Donaldson",
    title: "Stone Setter",
  },
  {
    name: "Melissa Doerting",
    title: "Stone Setter",
  },
];

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/teams/fpm/production",
  component: () => <TeamRosterPage team="Stone Setting Team" members={members} />,
});
